import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, ArrowLeft } from '@phosphor-icons/react';

/**
 * Shared visual chrome for Workforce Navigator prototype screens.
 * Includes the mandatory "PROTOTYPE — Not Live" banner + navigation.
 */
export const PrototypeShell = ({ title, subtitle, edition = 'Workforce Navigator™', children }) => {
  return (
    <div className="min-h-screen bg-surface-subtle font-body text-ink" data-testid="prototype-shell">
      {/* Prototype banner */}
      <div
        className="w-full bg-brand-gold text-brand-navy text-center py-2 px-4 text-xs font-semibold tracking-wide uppercase"
        data-testid="prototype-banner"
      >
        <span className="inline-flex items-center gap-2">
          <Eye size={14} weight="bold" />
          Prototype — For Product Review Only · Not connected to live data
        </span>
      </div>

      {/* Header */}
      <header className="bg-brand-navy text-white">
        <div className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link
              to="/prototypes/workforce"
              className="text-white/70 hover:text-brand-gold transition-colors inline-flex items-center gap-1 text-sm"
              data-testid="back-to-prototype-index"
            >
              <ArrowLeft size={16} /> Prototype Index
            </Link>
            <div className="h-6 w-px bg-white/20" />
            <div>
              <div className="text-[11px] tracking-widest uppercase text-brand-gold font-semibold">
                PLANIVANCE AI · {edition}
              </div>
              <h1 className="font-heading text-2xl leading-tight" data-testid="prototype-title">
                {title}
              </h1>
              {subtitle && <p className="text-white/70 text-sm mt-1">{subtitle}</p>}
            </div>
          </div>
          <div className="text-right text-xs text-white/60">
            <div>Sample Workforce Partner</div>
            <div className="text-white/40">Cohort · Spring 2026</div>
          </div>
        </div>
      </header>

      {/* Body */}
      <main className="max-w-7xl mx-auto px-6 py-10">{children}</main>

      <footer className="mt-16 border-t border-surface-border py-6 text-center text-xs text-ink-faint">
        © 2026 PLANIVANCE AI · Workforce Navigator™ Prototype ·
        <span className="ml-1">All data shown is synthetic</span>
      </footer>
    </div>
  );
};

export default PrototypeShell;
